import { Injectable } from '@angular/core';
import { MenuController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AOMenuService {

  private _stacked: any = ['lg'];

  constructor(
    public platform: Platform,
    public controller: MenuController,
  ) {
  }

  disable() {
    return this.controller.enable(false, 'AO_APP_MENU');
  }

  enable() {
    return this.controller.enable(true, 'AO_APP_MENU');
  }

  stackable() {
    return this.platform.width() > 991;
  }

  stacked() {
    return this._stacked;
  }

  stackToggle() {
    this._stacked = this._stacked == false ? ['lg'] : false;
  }

}
